<template>
	<section class="general">
		<!-- <ProfileDebug /> -->
	</section>
</template>

<style scoped lang="scss">
	.general {
		width: 100%;
	}
</style>
